/* eslint-disable no-plusplus */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useContext, useEffect } from 'react';
import {
  oneOf,
  bool as boolType,
  string as stringType,
  number as numberType,
} from 'prop-types';
import { useDataModel } from '@thd-nucleus/data-sources';
import { useStore, ExperienceContext } from '@thd-nucleus/experience-context';
import className from 'classnames';
import { ImpressionProvider } from '@thd-olt-component-react/impression';
import {
  shouldLoadFromStorage,
} from '../utils/recently-viewed';
import { isLoading, getAppId } from '../utils/helpers';
import { ProductPodV7Carousel } from '../core/ProductPodV7Carousel';
import { rvDataModel } from '../dataModel';
import { FallbackCard } from '../core/FallbackCard';

const RecentlyViewed = (props) => {
  const {
    brandTitleMaxLine,
    hideRating,
    hideTitle,
    schemaName,
    showLoading,
    hideATC,
    slidesPer,
    showFallback,
    entryId,
    hideCarouselArrows
  } = props;

  const { storeId, storeZip: zipCode, isLocalized } = useStore();
  const { channel, isConsumerApp } = useContext(ExperienceContext);

  const THDCustomer = typeof window !== 'undefined' ? window.THDCustomer?.default : {};
  const userId = THDCustomer.svocID || THDCustomer.userID || THDCustomer.guestUserID;
  const pAPIKey = '2zSR74pj5Rq6zDtHENHkAScT4RWsl0pg'; // TODO - THIS IS TEMP - This will change to 4 diff keys

  const opts = {
    variables: {
      storeId,
      key: pAPIKey,
      dataSource: schemaName,
      userId,
      unique: true,
      zipCode,
      apiName: 'views',
      appId: getAppId(channel, isConsumerApp),
      skipInstallServices: true
    },
    persist: {
      storage: 'sessionStorage',
      expirationInSeconds: 5 * 60
    },
    skip: !isLocalized || !userId,
    ssr: false,
    // Force new request if we should not load from storage/cache
    fetchPolicy: isLocalized && !shouldLoadFromStorage() ? 'network-only' : 'cache-first'
  };

  const { loading: recsLoading, data: recsData, error: recsError } = useDataModel('uds', opts);

  useEffect(() => {
    if (typeof LIFE_CYCLE_EVENT_BUS !== 'undefined' && !recsLoading && recsData && !recsError) {
      LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('RecentlyViewed.ready', { data: recsData?.uds });
    }
  }, []);

  const wrapperClasses = className(
    'sui-w-full', 'sui-pt-0', 'sui-pb-0',
    'sui-p-4',
    schemaName,
    // {
    //   loading: showLoading && recsLoading,
    // }
  );

  const fallbackInfo = {
    header: 'Get Back to Shopping',
    subheader: 'Check out our weekly ad for the latest sales',
    footerUrl: 'https://www.homedepot.com/c/localad',
    footer: 'Browse Weekly Ad'
  };

  if (recsError || (recsData !== undefined && (!recsData || !recsData?.uds) && !recsLoading)) {
    if (showFallback) {
      return (
        <FallbackCard
          header="Get Back to Shopping"
          subheader="Check out our weekly ad for the latest sales"
          footerUrl="https://www.homedepot.com/c/localad"
          footer="Browse Weekly Ad"
          componentName="RecentlyViewed"
        />
      );
    }
    return null;
  }

  if (!isLocalized || !userId) {
    return null;
  }

  const impressionData = {
    id: entryId || '',
    name: RecentlyViewed.displayName,
    component: RecentlyViewed.displayName,
    type: 'product',
    position: ''
  };

  return (
    <ImpressionProvider data={impressionData}>
      <div id={schemaName} className={wrapperClasses} data-type="container" data-component="RecentlyViewed">
        <meta data-prop="name" content={schemaName} />
        <ProductPodV7Carousel
          brandTitleMaxLine={brandTitleMaxLine}
          storeId={storeId}
          zipCode={zipCode}
          scheme={schemaName}
          showLoading={showLoading}
          parent="recently-viewed"
          hideRating={hideRating}
          hideFavorites
          hideATC={hideATC}
          hideTitle={hideTitle}
          data={recsData?.uds}
          loading={isLoading(recsData, recsLoading)}
          slidesPer={slidesPer}
          showFallback={showFallback}
          fallbackInfo={fallbackInfo}
          userId={userId}
          hideCarouselArrows={hideCarouselArrows}
        />
      </div>
    </ImpressionProvider>
  );
};

RecentlyViewed.dataModel = rvDataModel;

RecentlyViewed.displayName = 'RecentlyViewed';

RecentlyViewed.propTypes = {
  brandTitleMaxLine: numberType,
  hideRating: boolType,
  showLoading: boolType,
  schemaName: stringType.isRequired,
  hideATC: boolType,
  hideTitle: boolType,
  slidesPer: numberType,
  showFallback: boolType,
  entryId: stringType,
  hideCarouselArrows: boolType
};

RecentlyViewed.defaultProps = {
  brandTitleMaxLine: 4,
  hideRating: false,
  showLoading: true,
  hideATC: true,
  hideTitle: false,
  slidesPer: null,
  showFallback: false,
  entryId: null,
  hideCarouselArrows: false
};

export default RecentlyViewed;
